import { saga } from '../../businessRules/saga'

import { commercialInfluenceDone } from '../actions/newCommercialInfluence'
import { addCommercialInfluence } from '../actions/commercialInfluence'

export const newCommercialInfluenceSaga = influence => saga([addCommercialInfluence(influence), commercialInfluenceDone()])
